var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubscriptionRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49902 16.6665C6.01769 16.6665 3.99902 14.6478 3.99902 12.1665C3.99902 9.68517 6.01769 7.6665 8.49902 7.6665H15.499C17.9804 7.6665 19.999 9.68517 19.999 12.1665C19.999 14.6478 17.9804 16.6665 15.499 16.6665H8.49902ZM8.49902 8.6665C6.56902 8.6665 4.99902 10.2365 4.99902 12.1665C4.99902 14.0965 6.56902 15.6665 8.49902 15.6665H15.499C17.429 15.6665 18.999 14.0965 18.999 12.1665C18.999 10.2365 17.429 8.6665 15.499 8.6665H8.49902Z",
    fill: "#6CC980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.499 14.6665C15.223 14.6665 14.999 14.4425 14.999 14.1665V10.1665C14.999 9.8905 15.223 9.6665 15.499 9.6665C15.775 9.6665 15.999 9.8905 15.999 10.1665V14.1665C15.999 14.4425 15.775 14.6665 15.499 14.6665Z",
    fill: "#6CC980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.499 14.6665C13.223 14.6665 12.999 14.4425 12.999 14.1665V10.1665C12.999 9.8905 13.223 9.6665 13.499 9.6665C13.775 9.6665 13.999 9.8905 13.999 10.1665V14.1665C13.999 14.4425 13.775 14.6665 13.499 14.6665Z",
    fill: "#6CC980"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionRules);
export default __webpack_public_path__ + "static/media/subscription-rules.523af095.svg";
export { ForwardRef as ReactComponent };